import { getJSONByUrl } from 'widgets/toolbox/ajax';

/**
 * @description HarmonyPaymentsList implementation
 * @param {PaymentsList} PaymentsList widget for extending
 * @returns {typeof HarmonyPaymentsList}
 */
export default function (PaymentsList) {
    return class HarmonyPaymentsList extends PaymentsList {
        /**
         * @description Show confirmation dialog on remove card button click
         * @listens dom#click
         * @param {RefElement} card removed payment card
         * @returns {void}
         */
        removeCard(card) {
            this.cardToRemove = card;
            this.getById('confirmDialog', (confirmDialog) => {
                confirmDialog.showModal({ cardNumber: card.data('card') });
            });
        }

        /**
         * @description Remove card
         * @listens dom#click
         * @returns {void}
         */
        confirmedRemoveCard() {
            if (!this.cardToRemove) {
                return;
            }

            const promise = getJSONByUrl(
                this.cardToRemove.data('url'),
                { UUID: this.cardToRemove.data('id') }
            ).then((res) => {
                if (res.error) {
                    return;
                }

                const { paymentInstruments, isPaymentToDeleteDefault } = res;
                const isEmpty = !paymentInstruments.length;
                let accessibilityAlert = this.prefs().accessibilityAlerts.paymentRemoved;

                if (isPaymentToDeleteDefault && !isEmpty) {
                    accessibilityAlert = this.prefs().accessibilityAlerts.deleteDefaultPayment;
                }

                if (isEmpty) {
                    this.ref('msgBlock').show();
                }

                res.paymentInstruments.forEach(data => {
                    if(data.UUID === res.defaultWineClubPayment) {
                        data['isWineClubActive'] = true;
                    } else {
                        data['isWineClubActive'] = false;
                    }
                });

                this.render('paymentInstrumentsTemplate', {
                    paymentInstruments
                }, this.ref('paymentInstruments'));

                delete this.cardToRemove;

                this.eventBus().emit('alert.show', {
                    accessibilityAlert
                });
            });

            this.eventBus().emit('loader.start', promise);
        }

        /**
         * Makes a request to set selected CC as a default one
         * @param {RefElement} card
         */
        setDefault(card) {
            const promise = getJSONByUrl(
                card.data('url'),
                { UUID: card.data('uuid') }
            ).then((res) => {
                if (res.error) {
                    return;
                }
                res.paymentInstruments.forEach(data => {
                    if(data.UUID === res.defaultWineClubPayment) {
                        data['isWineClubActive'] = true;
                    } else {
                        data['isWineClubActive'] = false;
                    }
                });
                const accessibilityAlert = this.prefs().accessibilityAlerts.defaultPaymentChanged;
                    this.render('paymentInstrumentsTemplate', {
                        paymentInstruments: res.paymentInstruments
                    }, this.ref('paymentInstruments'));
                
                this.eventBus().emit('alert.show', {
                    accessibilityAlert
                });
            });

            this.eventBus().emit('loader.start', promise);
        }
    };
}
